import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: "30rem",
    display: "flex",
    flexDirection: "column",
  },

  headerContainer: {
    padding: theme.spacing(2),
  },

  tabList: {
    marginBottom: theme.spacing(1),
  },

  contentContainer: {
    flexGrow: 1,
    overflowY: "auto",
    padding: theme.spacing(2),
  },

  fieldItem: {
    width: "100%",
    marginBottom: theme.spacing(3),
  },

  tabPanelBox: {
    marginTop: theme.spacing(1),
  },
}));
